/**
 * Servicio de notificaciones: push del navegador + badge de pestaña + sonido
 */

// ─── Sonidos ──────────────────────────────────────────────────────────────────
const SOUNDS = {
  ding:    'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3',
  chime:   'https://assets.mixkit.co/active_storage/sfx/2868/2868-preview.mp3',
  pop:     'https://assets.mixkit.co/active_storage/sfx/2354/2354-preview.mp3',
  none:    null,
}

let audioCache = {}
let badgeCount = 0

function getAudio(tipo) {
  const url = SOUNDS[tipo]
  if (!url) return null
  if (!audioCache[tipo]) {
    audioCache[tipo] = new Audio(url)
    audioCache[tipo].volume = 0.6
  }
  return audioCache[tipo]
}

// ─── Badge de pestaña ─────────────────────────────────────────────────────────
export function setBadge(count) {
  badgeCount = count
  const title = document.title.replace(/^\(\d+\) /, '')
  document.title = count > 0 ? `(${count}) ${title}` : title

  // Navigator Badge API (Chrome 81+, Edge)
  if ('setAppBadge' in navigator) {
    count > 0
      ? navigator.setAppBadge(count).catch(() => {})
      : navigator.clearAppBadge().catch(() => {})
  }
}

export function incrementBadge() { setBadge(badgeCount + 1) }
export function clearBadge()     { setBadge(0) }

// ─── Permiso push ─────────────────────────────────────────────────────────────
export async function pedirPermiso() {
  if (!('Notification' in window)) return 'not_supported'
  if (Notification.permission === 'granted') return 'granted'
  if (Notification.permission === 'denied') return 'denied'
  const result = await Notification.requestPermission()
  return result
}

// ─── Enviar notificación push ─────────────────────────────────────────────────
export function notificar({ titulo, cuerpo, icono = '/favicon.ico', tag, onClick }) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return

  const n = new Notification(titulo, {
    body:  cuerpo,
    icon:  icono,
    badge: icono,
    tag:   tag || 'whatscrm',
    renotify: true,
  })

  n.onclick = () => {
    window.focus()
    onClick?.()
    n.close()
  }

  // Auto-cerrar en 6 segundos
  setTimeout(() => n.close(), 6000)
}

// ─── Sonido ───────────────────────────────────────────────────────────────────
export function reproducirSonido(tipo) {
  const preferencia = localStorage.getItem('notif_sonido') || 'ding'
  const audioTipo = tipo || preferencia
  const audio = getAudio(audioTipo)
  if (!audio) return
  audio.currentTime = 0
  audio.play().catch(() => {}) // silenciar error si el navegador bloquea autoplay
}

// ─── Helper principal: nuevo mensaje ─────────────────────────────────────────
// chatEstaAbierto = el usuario está mirando ese chat ahora mismo
export function notificarMensaje({ nombreContacto, texto, chatId, onClick, chatEstaAbierto = false }) {
  const sonido = localStorage.getItem('notif_sonido') || 'ding'
  const pushActivo = localStorage.getItem('notif_push') !== 'false'

  // Sonido e incremento de badge SIEMPRE (aunque el chat esté abierto)
  if (!chatEstaAbierto) {
    reproducirSonido(sonido)
    incrementBadge()
  }

  // Popup de sistema solo si el chat NO está abierto en pantalla
  if (pushActivo && !chatEstaAbierto) {
    notificar({
      titulo: `💬 ${nombreContacto || 'Nuevo mensaje'}`,
      cuerpo: texto?.slice(0, 100) || '(archivo adjunto)',
      tag:    chatId,
      onClick,
    })
  }
}

// ─── Precargar sonidos ────────────────────────────────────────────────────────
export function precargarSonidos() {
  Object.keys(SOUNDS).forEach(k => getAudio(k))
}

export const SONIDOS_DISPONIBLES = [
  { id: 'ding',  label: 'Ding'  },
  { id: 'chime', label: 'Chime' },
  { id: 'pop',   label: 'Pop'   },
  { id: 'none',  label: 'Sin sonido' },
]
